<template>
  <div class="unauthorized-page">
    <h1>Unauthorized Access</h1>
    <p>You do not have permission to view this page.</p>

    <router-link to="/" class="back-btn">Go to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "UnauthorizedPage",
  computed: {
    user() {
      return this.$store.state.user.currentUser;
    },
  },
};
</script>

<style scoped>
.unauthorized-page {
  text-align: center;
  padding: 50px;
}

h1 {
  color: #ff4d4f;
}

.back-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 5px;
}

.back-btn:hover {
  background-color: #0056b3;
}
</style>
